import newNode from './newNode';
import node from './node';
import refInput from './refInput';

export const yupSchemas = {
  newNode,
  node,
  refInput,
};
